export default "__VITE_PUBLIC_ASSET__941c321a__"